
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 20.75q-1.975 0-3.362-1.387Q2.25 17.975 2.25 16q0-1.65.988-2.913.987-1.262 2.512-1.662V13q-.875.375-1.438 1.188Q3.75 15 3.75 16q0 1.35.95 2.3.95.95 2.3.95 1.35 0 2.3-.95.95-.95.95-2.3v-.75h5.625q.175-.275.475-.45t.65-.175q.575 0 .975.4t.4.975q0 .575-.4.975t-.975.4q-.375 0-.663-.175-.287-.175-.462-.45H11.7q-.3 1.775-1.638 2.887Q8.725 20.75 7 20.75zm10 0q-1.225 0-2.25-.575t-1.675-1.55H15.1q.4.3.888.462.487.163 1.012.163 1.35 0 2.3-.95.95-.95.95-2.3 0-1.35-.95-2.3-.95-.95-2.3-.95-.475 0-.875.113-.4.112-.775.362L12.425 8.35q-.525-.025-.913-.4-.387-.375-.387-.95t.4-.975q.4-.4.975-.4t.975.4q.4.4.4.975 0 .15-.037.287-.038.138-.113.263L16 11.35q.225-.05.475-.075.25-.025.525-.025 1.975 0 3.363 1.387Q21.75 14.025 21.75 16t-1.387 3.363Q18.975 20.75 17 20.75zM7 17.375q-.575 0-.975-.4t-.4-.975q0-.525.375-.913.375-.387.925-.437l2.45-4.075q-.775-.675-1.2-1.6Q7.75 8.05 7.75 7q0-1.975 1.387-3.363Q10.525 2.25 12.5 2.25t3.363 1.387Q17.25 5.025 17.25 7h-1.5q0-1.35-.95-2.3-.95-.95-2.3-.95-1.35 0-2.3.95-.95.95-.95 2.3 0 1.075.6 1.887.6.813 1.575 1.163l-3.2 5.375q.075.15.113.287.037.138.037.288 0 .575-.4.975t-.975.4z"}})])
          )
        }
      }
    